import { Skeleton } from "@tellescope/ui";

export const MessagesSkeleton = () => (
  <div className="space-y-3 p-4">
    <div className="flex justify-start">
      <Skeleton className="h-16 w-48 rounded-2xl rounded-bl-md" />
    </div>
    <div className="flex justify-end">
      <Skeleton className="h-12 w-56 rounded-2xl rounded-br-md" />
    </div>
    <div className="flex justify-start">
      <Skeleton className="h-20 w-64 rounded-2xl rounded-bl-md" />
    </div>
    <div className="flex justify-end">
      <Skeleton className="h-10 w-40 rounded-2xl rounded-br-md" />
    </div>
  </div>
);
